import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {QuillModule} from 'ngx-quill';

import {SharedModule} from '../../shared/shared.module';
import {CaseAnnualService} from './case-annual.service';
import {CaseAnnualCreateComponent} from './create/create.component';
import {CaseAnnualEditComponent} from './edit/edit.component';
import {CaseAnnualFormComponent} from './form/form.component';
import {CaseAnnualListComponent} from './list/list.component';

@NgModule({
  declarations: [
    CaseAnnualListComponent,
    CaseAnnualCreateComponent,
    CaseAnnualEditComponent,
    CaseAnnualFormComponent,
  ],
  imports: [
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    QuillModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
  ],
  exports: [
    CaseAnnualListComponent,
    CaseAnnualCreateComponent,
    CaseAnnualEditComponent,
    CaseAnnualFormComponent,
  ],
  providers: [CaseAnnualService],
})
export class CaseAnnualRoutingModule {}
